import classNames from "classnames";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { addNoOverlayState } from "../../utils/UrlUtils";

const SectionMarker = ({
  title = "",
  hash,
  index,
  isHovered = false,
  setHovered,
  setHoveredIndex,
  isActive = false,
  inOverlay = false
}: {
  title?: string;
  hash: string;
  index: number;
  isHovered?: boolean;
  setHovered: (value: boolean) => void;
  setHoveredIndex: (index: number) => void;
  isActive?: boolean;
  inOverlay?: boolean;
}) => {
  const [mouseHovered, setMouseHovered] = useState(false);
  const [mouseDown, setMouseDown] = useState(false);

  return (
    <Link
      to={"#" + hash}
      replace={true}
      state={inOverlay === false ? addNoOverlayState() : {}}
      className={classNames("section-marker", {
        active: isActive,
        hovered: isHovered || mouseHovered,
        clicked: mouseDown
      })}
      onMouseEnter={() => {
        setMouseHovered(true);
      }}
      onMouseLeave={() => {
        setMouseHovered(false);
      }}
      onPointerDown={() => {
        console.log("onPointerDown");
        setMouseDown(true);
        setHovered(true);
        setHoveredIndex(index);
      }}
      onPointerUp={() => {
        console.log("onPointerUp");
        setMouseDown(false);
        setHovered(false);
        setHoveredIndex(-1);
      }}
    >
      <div className="dot" />
      <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
    </Link>
  );
};

export default SectionMarker;
